import { render, staticRenderFns } from "./Tutoring.vue?vue&type=template&id=a98d20d0&scoped=true&"
import script from "./Tutoring.vue?vue&type=script&lang=js&"
export * from "./Tutoring.vue?vue&type=script&lang=js&"
import style0 from "./Tutoring.vue?vue&type=style&index=0&id=a98d20d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98d20d0",
  null
  
)

export default component.exports